export default {"src":"/_next/static/media/app-googleplay.0fdc68a5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};